/* eslint-disable @next/next/no-img-element */
import React, {useState} from 'react';
import {Button} from 'antd';
import styles from './style.module.scss';
import {AtomicBlockUtils, EditorState} from 'draft-js';
import {Input} from '@/components/common-components/v2';
import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react';
import styled from 'styled-components';

interface Props {
  updateText: (state: EditorState) => void;
  editorState: any;
  setShowNewUrlEditor:any;
}

export const UploadURL = observer(({setShowNewUrlEditor, updateText, editorState}: Props) => {
  const {
    contentOptimizer: {
      currentPage: {currentEditorState},
    },
  } = useStore('');
  const imgRegex = /.(gif|png|apng|jpg|jpeg|tiff|webp|psd|indd|svg|bmp|xcf)((\?|\/).*)?$/;
  const [editorValues, setEditorValues] = useState({
    urlValue: '',
    altValue: '',
    height: 0,
    width: 0,
  });

  const imageFormat = url => editorValues.urlValue && !(imgRegex.test(url) && /^((http|https):\/\/)/.test(url));
  // Close anchor form popup by clicking anywhere on the screen

  const insertText = () => {
    const currentContent = currentEditorState.getCurrentContent();
    let imageUrl = '';
    const urlPattern = /^((http|https):\/\/)/;
    const formatUrl = urlPattern.test(editorValues.urlValue) ? editorValues.urlValue : `http://${editorValues.urlValue}`;
    imageUrl = formatUrl;
    if (imageUrl) {
      const contentStateWithEntity = currentContent.createEntity(
        'customImage',
        'IMMUTABLE',
        {src: imageUrl, alt: editorValues.altValue, height: editorValues.height ? `${editorValues.height}%` : '100%', width: editorValues.width ? `${editorValues.width}%` : '100%'},
      );
      const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
      const newEditorState = EditorState.set(editorState, {
        currentContent: contentStateWithEntity,
      });
      return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' ');
    }
    return editorState;
  };

  const sendTextToEditor = () => {
    const imageUrl = editorValues.urlValue;
    if (imageUrl) {
      const contentState = insertText();
      updateText(contentState);
      setEditorValues({
        urlValue: '',
        altValue: '',
        height: 0,
        width: 0,
      });
      setShowNewUrlEditor(false);
    }
  };

  const ele = document.getElementById('numberHeight');
  ele?.addEventListener('keydown', function(e) {
    const keyCode = e.which || e.keyCode;
    if (keyCode === 69 || keyCode === 187 || keyCode === 189) {
      e.preventDefault();
    }
  });

  const closeModal = () => {
    setEditorValues({
      urlValue: '',
      altValue: '',
      height: 0,
      width: 0,
    });
    setShowNewUrlEditor(false);
  };

  return (<>
    <p >Image source</p>
    <InputWraper>
      <Input
        onMouseDown={(e: any) => e.stopPropagation()}
        onChange={(e: any) =>
          setEditorValues({
            ...editorValues,
            urlValue: e.target.value,
          })
        }
        type='text'
        value={editorValues.urlValue}
        placeholder='Paste image URL...'
        className={styles.urlInput}
      />
    </InputWraper>
    {imageFormat(editorValues.urlValue) && <p style={{color: 'red', marginTop: '0'}}>Invalid image URL!</p>}
    <p>Alt tag (optional)</p>
    <InputWraper>
      <Input
        onMouseDown={(e: any) => e.stopPropagation()}
        onChange={(e: any) =>
          setEditorValues({
            ...editorValues,
            altValue: e.target.value,
          })
        }
        type='text'
        value={editorValues.altValue}
        placeholder=''
        className={styles.urlInput}
      />
    </InputWraper>
    <AtributeWrapper>
      <div>
        <p>Width (optional)</p>
        <InputWraper>
          <Input
            onMouseDown={(e: any) => e.stopPropagation()}
            onChange={(e: any) =>
              setEditorValues({
                ...editorValues,
                width: e.target.value < 101 && e.target.value !== 'e' ? e.target.value : e.target.value !== 'e' ? editorValues.width : 0,
              })
            }
            type='number'
            value={editorValues.width}
            placeholder=''
            max={100}
            min={0}
            className={styles.urlInput}
            id='numberHeight'
          />
        </InputWraper>
      </div>
      <div>
        <p>Height (optional)</p>
        <InputWraper>
          <Input
            onMouseDown={(e: any) => e.stopPropagation()}
            onChange={(e: any) =>
              setEditorValues({
                ...editorValues,
                height: e.target.value < 101 && e.target.value !== 'e' ? e.target.value : e.target.value !== 'e' ? editorValues.height : 0,
              })
            }
            type='number'
            value={editorValues.height}
            placeholder=''
            className={styles.urlInput}
            max={100}
            min={0}
            id='numberHeight'
          />
        </InputWraper>
      </div>
    </AtributeWrapper>
    <Pwrapper>
      <CancelBtn onClick={closeModal}>Cancel</CancelBtn>
      <AddBtn
        disabled={editorValues.urlValue?.trim().length == 0 || imageFormat(editorValues.urlValue)}
        onClick={sendTextToEditor}
      >
                Add to article
      </AddBtn>
    </Pwrapper>
  </>
  );
});

const InputWraper = styled.div`
  margin-top: 10px;
  background-color: rgba(249, 249, 251, 1) !important;
  border-radius: 9px;
  .ant-input {
    background-color: transparent !important;
    border: none !important;
    margin-bottom: 0 !important;
    padding: 20px 8px 20px 11px !important;
  }
  .ant-input:focus,
  .ant-input-focused {
    box-shadow: none !important;
  }
  p {
    align-items: center;
    display: flex;
    padding: 0 17px 0 10px;
    border-left: 2px solid #c9c7c7;
    margin: 9px 0 7px 0;
    color: blue;
    cursor: pointer;
  }
`;

const Pwrapper = styled.div`
  text-align: initial;
  margin: 18px 0 0 8px;
  font-weight: 400;
  display: flex;
  justify-content: end;
  span {
    color: blue;
  }
  .ant-btn[disabled]{
    background-color: #2d6cca80 !important;
    span{
      color: white !important;
    }
  }
`;

const AtributeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  .ant-input {
    width: 143px !important;
  }
`;

const CancelBtn = styled(Button)`
  background-color: transparent;
  color: black !important;
  height: 38px;
  border-radius: 9px;
  border: 1px solid lightgray !important;
  &:hover{
    background-color:white !important;
    color:black;
    border: 1px solid lightgray;

  }
  span{
    color: black;
  }
`;

const AddBtn = styled(Button)`
  margin-left: 15px;
  background-color: #2D6CCA;
  height: 38px;
  border-radius: 9px;
  span {
    color: white;
  }
  &:hover {
    background-color: #2D6CCA;
  }
`;
